import { render, staticRenderFns } from "./TermsSection.vue?vue&type=template&id=ca7e0bc4&scoped=true"
import script from "./TermsSection.vue?vue&type=script&lang=js"
export * from "./TermsSection.vue?vue&type=script&lang=js"
import style0 from "./TermsSection.vue?vue&type=style&index=0&id=ca7e0bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7e0bc4",
  null
  
)

export default component.exports